import { render, staticRenderFns } from "./MyDogRegistrationIndividualRequestsList.vue?vue&type=template&id=0e2236f4"
import script from "./MyDogRegistrationIndividualRequestsList.vue?vue&type=script&lang=ts"
export * from "./MyDogRegistrationIndividualRequestsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports